export const ConnectWalletReducer = (state = {}, action) => {
  switch (action.type) {
    case "CONNECT_WALLET":
      return action.payload;

    default:
      return state;
  }
};
